import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { TranslationModule } from 'src/app/i18n';
import { ShareModule } from 'src/app/shared/share.module';
import { PagesSharedModule } from '../../shared/pages-shared.module';
import { PrivateNumberUploadDocumentsModule } from '../private-number-upload-documents-form/private-number-upload-documents-form.module';
import { PrivateNumberPriceSharedModule } from './../shared/private-number-price-shared.module';
import { PrivateNumberDocumentationComponent } from './private-number-documentation.component';

@NgModule({
  declarations: [PrivateNumberDocumentationComponent],
  imports: [
    CommonModule,
    ShareModule,
    TranslationModule,
    ReactiveFormsModule,
    FormsModule,
    PagesSharedModule,
    SharePipesModule,
    PrivateNumberPriceSharedModule,
    PrivateNumberUploadDocumentsModule,
  ],
  exports: [PrivateNumberDocumentationComponent],
})
export class PrivateNumberDocumentationModule {}
